import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ASSETS } from "@/lib/brand";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("wg_admin_token", data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md">
        <img src={ASSETS.logo} alt="Watson Group" className="h-14 mx-auto mb-10" />
        <p className="overline text-[#CBBFAE] text-center mb-4">Portal</p>
        <h1 className="font-serif text-4xl text-white text-center mb-12">Admin Access</h1>
        <input
          data-testid="admin-login-email"
          type="email"
          className="line-input"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          data-testid="admin-login-password"
          type="password"
          className="line-input"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="mt-10 w-full border border-[#CBBFAE]/50 hover:border-[#CBBFAE] rounded-full py-3 text-[12px] tracking-[0.3em] uppercase text-white transition-all disabled:opacity-50"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
